import React from "react";
import { Marker, Tooltip } from "react-leaflet";
import L from "leaflet";

const LocationMarker = ({ position }) => {
  const iconMarkup = `
    <div>
      <div class="pulse-dot"></div>
      <div class="pulse-ring"></div>
      <div class="pulse-ring"></div>
    </div>
  `;

  const customIcon = L.divIcon({
    className: "custom-div-icon",
    html: iconMarkup,
    iconSize: [50, 50],
    iconAnchor: [25, 25],
  });
  return (
    <Marker position={position} icon={customIcon}>
      <Tooltip permanent direction="top">
        <div className="d-flex gap-1">
          <span>
            <strong>Lat</strong> {position.lat.toFixed(4)},
          </span>
          <span>
            <strong>Lng</strong> {position.lng.toFixed(4)}
          </span>
        </div>
      </Tooltip>
    </Marker>
  );
};

export default LocationMarker;
